import { Slot } from 'radix-ui';
import type { ReactNode } from 'react';
import { Icon, type IconName } from '../icon/Icon';
import { cn } from '../utils';

type HeaderNavLinkBaseProps = {
  children: ReactNode;
  className?: string;
};

export type HeaderNavLinkProps = HeaderNavLinkBaseProps &
  ({ asChild: true } | { asChild?: false; href: string; external?: boolean; icon?: IconName });

const baseClassName = cn(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-2 font-semibold text-nav text-white transition-colors',
  'hover:bg-white/[0.08]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring-on-dark',
);

export function HeaderNavLink({ children, className, ...rest }: HeaderNavLinkProps) {
  const classes = cn(baseClassName, className);

  if (rest.asChild) {
    return <Slot.Root className={classes}>{children}</Slot.Root>;
  }

  const { href, external, icon } = rest;
  const trailingIcon = icon ?? (external ? 'external-link' : undefined);

  return (
    <a href={href} className={classes} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined}>
      <span>{children}</span>
      {trailingIcon ? <Icon name={trailingIcon} size="lg" /> : null}
    </a>
  );
}
